export const SALT = "SGC@ERIK!@!$$$!@!2025";
export const API_URL = process.env.NODE_ENV === "production"
  ? "https://staging.servinggodschildren.com/api/v1"
  : "https://staging.servinggodschildren.com/api/v1";